const containerStack = (theme) => ({
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: '0.8fr 1.5fr',
    md: '0.8fr 1.5fr',
    lg: '0.8fr 0.7fr 1.5fr',
  },
  gridTemplateAreas: {
    xs: `
      "links"
      "contact"
      "logo"
      "legal"
      "disclaimers"
    `,
    sm: `
      "links links"
      "contact contact"
      "logo legal"
      "disclaimers disclaimers"
    `,
    md: `
      "links contact"
      "logo legal"
      "disclaimers disclaimers"
    `,
    lg: `
      "links logo contact"
      "legal legal legal"
      "disclaimers disclaimers disclaimers"
    `,
  },
  gap: '2rem',
  background: `linear-gradient(180deg, ${theme.palette.contrast.A700} 0%, #000 100%)`,
  padding: { xs: '1rem', s: '3rem', md: '5rem' },
});

const linksStack = {
  gridArea: 'links',
  gap: '0.5rem',
  minWidth: '5rem',
  maxWidth: '100%',
};

const linkTypography = (theme) => ({
  color: theme.palette.neutral.A400,
  fontWeight: 500,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
});

const logoStack = {
  gridArea: 'logo',
};

const contactStack = {
  gridArea: 'contact',
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  justifyContent: 'space-between',
  gap: '1rem',
  width: '95%',
};

const legalStack = {
  display: 'flex',
  gridArea: 'legal',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: 'flex-start',
  gap: '1.5rem',
};

const disclaimersStack = {
  display: 'flex',
  gridArea: 'disclaimers',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '1.5rem',
};

const disclaimerTypography = (theme) => ({
  fontWeight: 500,
  color: theme.palette.neutral.A400,
  textAlign: { xs: 'justify', phone: 'left' },
});

export {
  containerStack,
  linksStack,
  linkTypography,
  logoStack,
  contactStack,
  legalStack,
  disclaimersStack,
  disclaimerTypography,
};
